export const GET_CHAPTERS = 'GET_CHAPTERS';
export const MIX_CHAPTERS = 'MIX_CHAPTERS';
export const GET_CHAPTER = 'GET_CHAPTER';
export const ADD_CHAPTER = 'ADD_CHAPTER';
export const DELETE_CHAPTER = 'DELETE_CHAPTER';
export const UPDATE_CHAPTER = 'UPDATE_CHAPTER';
export const UPDATE_CHAPTER_NAME = 'UPDATE_CHAPTER_NAME';
export const SET_SYNC_FOR_CURRENT_CHAPTER = 'SET_SYNC_FOR_CURRENT_CHAPTER';
export const UPDATE_SYNC_FOR_CURRENT_CHAPTER = 'UPDATE_SYNC_FOR_CURRENT_CHAPTER';
export const DELETE_SYNC_FOR_CURRENT_CHAPTER = 'DELETE_SYNC_FOR_CURRENT_CHAPTER';
export const ADD_SYNC_FOR_CURRENT_CHAPTER = 'ADD_SYNC_FOR_CURRENT_CHAPTER';
export const ADD_AUDIO_FOR_CURRENT_CHAPTER = 'ADD_AUDIO_FOR_CURRENT_CHAPTER';
export const DELETE_AUDIO_FOR_CURRENT_CHAPTER = 'DELETE_AUDIO_FOR_CURRENT_CHAPTER';
export const GET_ARTISTS = 'GET_ARTISTS';

